import React from "react";
import "./GetMusicOnBMAT.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnBMAT = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music catalog",
    "Select BMAT monitoring",
    "Music tracked globally",
    "Usage identified across platforms",
    "Receive accurate royalties data"
  ];

  return (
    <>
      <Helmet>
        <title>
          BMAT Music Innovators Distribution | Music Tracking & Monitoring | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute and track your music globally with BMAT Music Innovators via FT Tunes. Monitor broadcasts, performances, and digital usage worldwide."
        />

        <meta
          name="keywords"
          content="BMAT distribution, music monitoring, music tracking platform, BMAT Music Innovators, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="bmat-page">

        {/* HERO */}
        <section className="bmat-hero">
          <Container>

            <img
              src="/Images/bmat-logo.png"
              alt="BMAT Music Innovators"
              className="bmat-logo"
            />

            <h1>Distribute & Track Music with BMAT</h1>

            <p>
              Monitor how your music is used worldwide with BMAT Music
              Innovators. Track broadcasts, performances, and digital
              usage across global platforms with industry-leading accuracy.
            </p>

            <Button
              className="gradient-btn-bmat"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-bmat"></div>
        </section>


        {/* SHOWCASE */}
        <section className="bmat-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Global Music Monitoring</h2>

                <p>
                  BMAT helps artists, labels, and publishers understand
                  exactly where their music is being played — TV,
                  radio, streaming platforms, live events, and more.
                </p>

                <Button
                  className="outline-btn-bmat"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-bmat.png"
                  alt="BMAT Monitoring"
                  className="bmat-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="bmat-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-bmat">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="bmat-benefits">
          <Container>

            <h2 className="section-title">
              Why Use BMAT Music Innovators
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-bmat">
                  <h5>Global Tracking</h5>
                  <p>Monitor music usage worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-bmat">
                  <h5>Broadcast Detection</h5>
                  <p>Track TV, radio & live plays.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-bmat">
                  <h5>Accurate Data</h5>
                  <p>Reliable music usage analytics.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-bmat">
                  <h5>Artist Transparency</h5>
                  <p>Know exactly where music performs.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="bmat-cta">
          <Container>

            <h2>Track Your Music Worldwide Today</h2>

            <Button
              className="gradient-btn-bmat big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnBMAT;